import {AOperationWithEquipment} from "./AOperationWithEquipment";
import GPSCoordinates from "../GPSCoordinates";
import {EOperationType} from "../utils/EOperationType";
import {Icon} from "../Icon";
import MarkerIconService from "../../services/map/MarkerIconService";
import {CSS_CLASS_NAME_GRAY_MARKER, CSS_CLASS_NAME_ORANGE_MARKER} from "../../services/UtilsService";

export class Geolocate extends AOperationWithEquipment {

    constructor(id: string, idUser: string, date: Date, equipmentId?: string, geolocation?: GPSCoordinates, isSynchro?: boolean, commentary?: string) {
        const icon = new Icon(
            MarkerIconService.OPERATION_GEOLOCATE_ICON_PATH,
            MarkerIconService.generateIcon(MarkerIconService.OPERATION_GEOLOCATE_ICON_PATH, isSynchro ? CSS_CLASS_NAME_ORANGE_MARKER : CSS_CLASS_NAME_GRAY_MARKER)
        );
        super(id, idUser, EOperationType.Geolocate, date, icon, geolocation, isSynchro, commentary, equipmentId);
    }

    public static remapObjectToOperation(object: any): Geolocate | null {
        let operation: Geolocate | null = null;
        if(
            object._id &&
            object._idUser &&
            object._date &&
            object._geolocation &&
            object._equipmentId
        ) {
            const location = GPSCoordinates.remapObjectToGPSCoordinate(object._geolocation);
            if(location) {
                operation = new Geolocate(
                    object._id,
                    object._idUser,
                    object._date,
                    object._equipmentId,
                    location,
                    object._isSynchro,
                    object._commentary
                );
            }
        }
        return operation;
    }
}

